// extracted by mini-css-extract-plugin
export default {"header":"header---Bckpy","headerText":"headerText---cbYF9"};